import { AppForm, AppFormItem, formRules } from 'shared/UI/UIKit/Form';
import { AppInput } from 'shared/UI/UIKit/Input';
import { AppMultipleSelect } from 'shared/UI/UIKit/Select';
import type { AppFormInstance } from 'shared/UI/UIKit/Form';
import { useFormService } from '../model';

export interface RoomFormProps {
  form: AppFormInstance;
}

export const RoomForm = ({ form }: RoomFormProps) => {
  const {
    state: { subjects, subjectIsLoading },
  } = useFormService();

  return (
    <AppForm form={form}>
      <AppFormItem rules={formRules.required} label="Номер аудитории" name="number">
        <AppInput placeholder="Введите номер аудитории" />
      </AppFormItem>
      <AppFormItem rules={formRules.required} label="Название аудитории" name="name">
        <AppInput placeholder="Введите название аудитории" />
      </AppFormItem>
      <AppFormItem
        label="Список предметов, допустимых для аудитории"
        name="subjectsIds"
        rules={formRules.requiredArray}
      >
        <AppMultipleSelect
          options={subjects}
          loading={subjectIsLoading}
          style={{ minHeight: '40px', height: 'auto' }}
        />
      </AppFormItem>
    </AppForm>
  );
};
